import CashRegistersApi from '@/services/shop/CashRegistersApi'

export interface CashRegisterInterface {
  id: string
  name: string
  label: string
  arena_id: bigint
  created_at: string
  updated_at: string
}

export class CashRegisterDTO implements CashRegisterInterface {
  id = ''
  name = ''
  label = ''
  arena_id = 0n
  created_at = ''
  updated_at = ''
}

export default class CashRegister extends CashRegisterDTO {
  static api = CashRegistersApi

  constructor(DTO: CashRegisterDTO) {
    super()
    Object.assign(this, DTO)
  }
}
